document.querySelectorAll(".beer-slider").forEach(el => {
    new BeerSlider(el);
    const handle = el.querySelector(".beer-handle");
    if (handle) {
        const div = document.createElement("div");
        handle.appendChild(div);
    }
    else {
        console.warn("No .beer-handle found");
    }
});